module.exports = __webpack_public_path__ + "static/media/needs-3-outline.a11526a4.png";